module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/129.56f44d7f.png";